import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";
  import { computed, onMounted, ref } from "vue";
  import { useToast } from "vue-toastification";

  const tooltipText = "No subscriptions applied to your account";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSubscription',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();
  const loading = ref(false);
  const chargebeeCustomerId = computed(() => {
    return store.state.user.data.detailsId.chargebeeCustomerId;
  });

  const landownerId = computed(() => {
    return store.state.user.data._id;
  });

  onMounted(() => {
    loading.value = true;
    store
      .dispatch("user/updateUserProfile", landownerId.value)
      .finally(() => (loading.value = false));
  });

  const getChargebeePortalSession = () => {
    loading.value = true;
    store
      .dispatch("user/getChargebeePortalSession")
      .then((res) => {
        window.open(res.data, "_self");
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      })
      .finally(() => (loading.value = false));
  };

const __returned__ = { toast, loading, tooltipText, chargebeeCustomerId, landownerId, getChargebeePortalSession, get store() { return store }, computed, onMounted, ref, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})